import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { toast } from '@/lib/v2/components';

import { useService } from '@/src/infrastructure/Protocol/useEmblue';

export const useActionsRules = () => {
  const { t } = useTranslation();
  const service = useService();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const deleteAction = useCallback(
    async (ids: number[]) => {
      if (!service) return;
      setIsLoading(true);
      const response = await service.deleteV1Actions(ids);
      if (response.statusOK) {
        toast({
          variant: 'success',
          title: t('useActionsJourneys.deleteAction.title.success'),
          body:
            ids.length === 1
              ? t('useActionsRules.deleteAction.body.success')
              : t('useActionsRules.deleteAction.multiply.body.success'),
        });
      } else {
        toast({
          variant: 'error',
          title: t('useActionsJourneys.deleteAction.title.error'),
          body: t('useActionsJourneys.deleteAction.body.error'),
        });
      }
      setIsLoading(false);
    },
    [service, t]
  );

  const duplicateRule = useCallback(
    async (name: string, id: number) => {
      if (!service) return;
      setIsLoading(true);
      const response = await service.duplicateRule(name, id);
      if (response.success) {
        toast({
          variant: 'success',
          title: t('useActionsJourneys.duplicateMessage.title.success'),
          body: t('useActionsRules.duplicateMessage.body.success'),
        });
        setIsLoading(false);
        return { isValidInput: response.success, message: response.data };
      } else {
        setIsLoading(false);
        return {
          isValidInput: response.success,
          message: t(`useActionsRules.duplicateMessage.body.error.RULE_ALREADY_EXISTS`),
        };
      }
    },
    [service, t]
  );

  const renameRule = useCallback(
    async (name: string, messageID: number) => {
      if (!service) return;
      setIsLoading(true);
      const response = await service.renameRule(name, messageID);
      if (response.success) {
        toast({
          variant: 'success',
          title: t('useActionsJourneys.renameMessage.title.success'),
          body: t('useActionsJourneys.renameMessage.body.success'),
        });
        setIsLoading(false);
        return { isValidInput: response.success, message: response.data };
      } else {
        setIsLoading(false);
        return {
          isValidInput: response.success,
          message: t(`useActionsRules.duplicateMessage.body.error.RULE_ALREADY_EXISTS`),
        };
      }
    },
    [service, t]
  );

  return { deleteAction, isLoading, duplicateRule, renameRule };
};
